import React from "react"
import { useFormSubmissionScheduledReportExportContext } from "contexts/FormSubmissionScheduledReportExportContext"
import SubmissionFilters from "shared/ScheduledReportExport/SubmissionFilters"

const NewFormSubmissionScheduledReportExportSubmissionFilters = () => {
  const {
    dateFilterType,
    startDate,
    submissionPreviousRangeLength,
    submissionPreviousRangeUnit,
    setSubmissionPreviousRangeLength,
    lengthOptions,
  } = useFormSubmissionScheduledReportExportContext()

  return (
    <SubmissionFilters
      dateFilterType={dateFilterType}
      startDate={startDate}
      submissionPreviousRangeLength={submissionPreviousRangeLength}
      submissionPreviousRangeUnit={submissionPreviousRangeUnit}
      setSubmissionPreviousRangeLength={setSubmissionPreviousRangeLength}
      lengthOptions={lengthOptions}
    />
  )
}

export default NewFormSubmissionScheduledReportExportSubmissionFilters
